import { getEntityDataByViewState } from '../entities/generic'

export const getStoriesViewState = (state) =>
  getEntityDataByViewState(state).storiesView || {}
